import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ImpersonationEffects } from './+state/impersonation.effects';
import { impersonationReducer } from './+state/impersonation.reducer';
import { IMPERSONATION_FEATURE_KEY } from './+state/impersonation.selectors';
import { impersonationInterceptor } from './impersonation.interceptor';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(IMPERSONATION_FEATURE_KEY, impersonationReducer),
    EffectsModule.forFeature([ImpersonationEffects])
  ],
  providers: [provideHttpClient(withInterceptors([impersonationInterceptor]))]
})
export class ImpersonationModule {}
